import { ChangeDetectorRef, Component, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as FileSaver from 'file-saver';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ProjetIndicateur } from 'src/app/shared/models/projet';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { ProjetIndicateurService } from '../../plananalytique/programme/projet-indicateur/projet-indicateur.component';
import { ChartModule } from 'primeng/chart';

@Component({
  selector: 'app-tep-direction',
  standalone: false,
  templateUrl: './tep-direction.component.html',
  styleUrl: './tep-direction.component.scss'
})


export class TepDirectionComponent {

  annee: any;
  items: any = [] = [];
  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;
  paginatedProjets: any = [];


  firstProjets1: number = 0;
  rowsProjets1: number = 2;
  totalRecords1: number = 0;
  paginatedProjets1: any = [];

  displayModalTaches: boolean = false;
  tacheItems: any = [];
  isLoadingModalTaches: boolean = false;
  firstTaches: number = 0;
  rowsTaches: number = 10;
  totalRecordsTaches: number = 0;
  paginatedTaches: any = [];
  currentDirectionId: any;
  currentActiviteId: any;
  activiteLibelle: string;

  user: any;
  dateDebut: string;
  dateFin: string;
  directionItems: any = [];
  ptaItems: any = [];
  displayModal: boolean = false
  directionId: any;
  isLoading: boolean = false;
  isLoadingModal: boolean = false;
  @ViewChild('tepModal') modalContent: TemplateRef<any>;
  histogramData: any = {};
chartOptions: any = {};
  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private projetService: ProjetIndicateurService,
    private ngxService: NgxUiLoaderService,
    private router: Router,
    private cdr: ChangeDetectorRef 
  ) {
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();
    const today = new Date();
    const exercice = this.localstorage.getExerciceToUserToSuivieEvaluation();

    this.dateDebut = `${exercice}-01-01`;
    this.dateFin = new Date().toISOString().split('T')[0];


  }
  ngOnInit() {
    this.user = this.localstorage.getInfoUserToService()?.data;
    //console.log("  this.user", this.user);
    this.directionId = this.user?.service?.direction?.reference,
      this.getStatistiqueTepByDirection();
  }

  //statistiques tep par direction
  getStatistiqueTepByDirection() {
    this.ngxService.start();
    const requestData = {
      annee: this.annee,
      direction_id: this.directionId,
      user_reference: this.user.reference,
      type_operation: "data",
      date_debut: this.dateDebut,
      date_fin: this.dateFin
    }
    this.paramservice.getStatistiqueprogrammeByDirection(requestData).subscribe(
      (response: any) => {
        this.items = response.data;
        this.totalRecords = this.items.length;
        this.updatePaginatedProjets();
        this.prepareHistogramData();
        this.isLoading = false;
        this.ngxService.stop();
        ////console.log("this.actionData",this.serviceData);
      },
      (error) => {
        //console.log("une erreur est survenu", error);
        this.ngxService.stop();
         this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error?.message || 'Une erreur est survenue lors du chargement des données',
          });
      }
    );
  }//end getStatistiqueTepByDirection


  // Remplacer prepareHistogramData() par :
prepareHistogramData() {
  if (!this.items || this.items.length === 0) return;

  const directions = this.items.map(item =>
    (item.direction?.libelle || 'N/A').length > 25
      ? (item.direction?.libelle || 'N/A').substring(0, 23) + '...'
      : (item.direction?.libelle || 'N/A')
  );

  this.histogramData = {
    labels: directions,
    datasets: [
      {
        label: 'TEP Prévu (%)',
        data: this.items.map(item => parseFloat(item.tep_prevu) || 0),
        backgroundColor: 'rgba(54, 162, 235, 0.8)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
        borderRadius: 4,
        barPercentage: 0.7
      },
      {
        label: 'TEP Réalisé (%)',
        data: this.items.map(item => parseFloat(item.tep_realise) || 0),
        backgroundColor: 'rgba(75, 192, 192, 0.8)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
        borderRadius: 4,
        barPercentage: 0.7
      }
    ]
  };

  this.chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: { font: { size: 12, weight: 'bold' }, usePointStyle: true }
      },
      title: {
        display: true,
        text: `Comparaison TEP Prévu vs Réalisé - ${this.annee}`,
        font: { size: 16, weight: 'bold' },
        padding: { top: 10, bottom: 20 }
      },
      tooltip: {
        callbacks: {
          label: (context: any) => `${context.dataset.label}: ${context.raw}%`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        title: { display: true, text: 'TEP (%)', font: { weight: 'bold' } },
        ticks: { callback: (value: any) => value + '%', stepSize: 20 }
      },
      x: {
        title: { display: true, text: 'Directions', font: { weight: 'bold' } },
        ticks: { maxRotation: 35, minRotation: 35 }
      }
    }
  };

  this.cdr.detectChanges();
}
  onPageChangeProjets(event) {
    this.firstProjets = event.page * this.rowsProjets; // Mise à jour de la page actuelle
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.items.slice(start, end);
  }//end updatePaginatedProjets

  //Liste des directions
  getDirection() {

    this.paramservice.fetchDataDirection().subscribe(

      (response: any) => {

        ////console.log("la reponse du webservice", response);

        this.directionItems = response.data;

      },
      (error) => {

        ////console.log("une erreur est survenu", error);

      }
    )
  }

  exportToDocument(typeDoc: any) {
    const requestData = {
      annee: this.annee,
      direction_id: this.directionId,
      user_reference: this.user.reference,
      type_operation: typeDoc,
      date_debut: this.dateDebut,
      date_fin: this.dateFin
    }
    this.ngxService.start();

    this.paramservice.getStatistiqueprogrammeByDirectionDocument(requestData).subscribe(
      (response: Blob) => {
        let filename = '';
        let mimeType = '';
        let successMessage = '';

        if (typeDoc === 'pdf') {
          filename = 'Statistiques_pta_direction.pdf';
          mimeType = 'application/pdf';
          successMessage = 'Le fichier PDF a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        } else {
          filename = 'Statistiques_pta_direction.xlsx';
          mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          successMessage = 'Le fichier Excel a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          FileSaver.saveAs(blob, filename);
        }

        this.ngxService.stop();
        this.messageService.add({ severity: 'success', summary: 'Téléchargement réussi', detail: successMessage, life: 3000 });
      },
          (error: any) => {
        this.ngxService.stop();

        if (error.error instanceof Blob) {

          const reader = new FileReader();

          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result as string);

              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: err.message || 'Téléchargement échoué'
              });

            } catch (e) {
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Erreur lors du traitement du message'
              });
            }
          };

          reader.readAsText(error.error);

        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error?.message || 'Téléchargement échoué'
          });
        }
      }
    );

  }
  closeModal() {
    this.displayModal = false;
  }

  serviceLibelle: any;


  //afficher activites par direction
  openModalActivitesParDirection(item: any) {
    this.serviceLibelle = item.direction.libelle;
    this.currentDirectionId = item.direction.id;

    // Reset pagination to first page
    this.firstProjets1 = 0;
    this.rowsProjets1 = 10;
    this.displayModal = true;
    this.getPtaActivitesByDirection(item);
  }//end openModalActivitesParDirection

  //get pta by service
  getPtaActivitesByDirection(item: any) {
    this.isLoadingModal = true;

    const requestData = {
      direction_id: item.direction.id,
      user_reference: this.user.reference,
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      type_operation: "data"
    }
    this.paramservice.getStatistiquePtaByDirection(requestData).subscribe(

      (response: any) => {
        ////console.log("la reponse du webservice", response);
        this.ptaItems = response.data;
        this.totalRecords1 = this.ptaItems.length;
        this.updatePaginatedProjets1();
        this.isLoadingModal = false;
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
        this.isLoadingModal = false;
      }
    )
  }//end getPtaActivitesByDirection

  onPageChangeProjets1(event) {
    this.firstProjets1 = event.page * this.rowsProjets1;
    this.updatePaginatedProjets1();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets1() {
    const start = this.firstProjets1;
    const end = start + this.rowsProjets1;
    this.paginatedProjets1 = this.ptaItems.slice(start, end);
  }//end updatePaginatedProjets


  //detail taches par activite (direction)
  openModalTachesByDirection(act: any) {
    this.activiteLibelle = act.activite.activite;
    this.currentActiviteId = act.activite.id;
    this.displayModalTaches = true;
    this.isLoadingModalTaches = true;
    this.firstTaches = 0;
    this.rowsTaches = 10;

    const requestData = {
      direction_id: this.currentDirectionId,
      activite_id: this.currentActiviteId,
      user_reference: this.user.reference,
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      type_operation: "data"
    };
    this.paramservice.getDetailTachesByDirection(requestData).subscribe(
      (response: any) => {
        this.tacheItems = response.data;
        this.totalRecordsTaches = this.tacheItems.length;
        this.updatePaginatedTaches();
        this.isLoadingModalTaches = false;
      },
      (error) => {
        this.isLoadingModalTaches = false;
      }
    );
  }

  closeModalTaches() {
    this.displayModalTaches = false;
  }

  onPageChangeTaches(event) {
    this.firstTaches = event.page * this.rowsTaches;
    this.updatePaginatedTaches();
  }

  updatePaginatedTaches() {
    const start = this.firstTaches;
    const end = start + this.rowsTaches;
    this.paginatedTaches = this.tacheItems.slice(start, end);
  }

  getAnnees(pdc: any): number[] {
    const anneesSet = new Set<number>();

    for (const act of pdc.details_pdc_activites || []) {
      for (const fin of act.details_pdc_financements_activites || []) {
        anneesSet.add(fin.annee);
      }
    }

    return Array.from(anneesSet).sort();
  }
  getMontantParAnnee(financements: any[], annee: number): number {
    const fin = financements?.find(f => f.annee === annee);
    return fin ? fin.montant : 0;
  }
}
